module.exports = __webpack_public_path__ + "static/assets/2237d324b3eee27c3b64ece398a303db.svg";